export default "__VITE_ASSET__wmvDBzOF__"